import { db } from "../../util/firebase";

export const login = async (link, UserCallBack) => {
  const linkSnapshot = await db.collection("links").doc(link.id).get();
  const linkData = linkSnapshot.data();

  if (linkData) {
    let activityObj = {
      type: "LOGIN",
      date: new Date(),
      link: link.id,
    };
    await db.collection("activity").add(activityObj);
    sessionStorage.setItem("linkAuth", true);
    sessionStorage.setItem("linkId", link.id);
    sessionStorage.setItem("prevLink", link.id);
    UserCallBack("");
  } else {
    UserCallBack("The link you are trying to access doesn't exist");
  }
};

export const logout = (callBack) => {
  sessionStorage.setItem("linkAuth", false);
  callBack();
};
